<form [formGroup]="form">
  @if (showInput) {
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{ "Phone Number" | translate }}</mat-label>
      <ngx-mat-input-tel
        [onlyCountries]="onlyCountries"
        [enableSearch]="true"
        [enablePlaceholder]="true"
        formControlName="PHONE"
      />
      @if (phone?.hasError("required")) {
        <mat-error> {{ "Phone number is required." | translate }} </mat-error>
      }
      @if (
        phone?.hasError("pattern") || phone?.errors?.["validatePhoneNumber"]
      ) {
        <mat-error>
          {{ "Invalid phone number format." | translate }}
        </mat-error>
      }
    </mat-form-field>
  }

  @if (!initialValue?.COUNTRY) {
    <span class="country-notice">
      {{ "A country must be selected to set the phone number." | translate }}
    </span>
  }
</form>
